export const ModalTypes = {
    INACTIVE: 'inactive',
    LOGIN: 'login',
    DOWNLOAD: 'download',
    FORGOT: 'forgot',
    NEWSLETTER: 'newsletter',
    PASSWORD: 'password',
    PROFILE: 'profile',
    RATE: 'rate',
    TIMEOUT: 'timeout',
    PURCHASE: 'purchase',
    COOKIE: 'cookie',
    REDEEM: 'redeem',
    CONTACT: 'contact',
    DELETE: 'delete',
    CHANGE: 'change'
  };
  
  export enum MessageType {
    ERROR = 'error',
    WARNING = 'warning',
    SUCCESS = 'success',
    INFO = 'info'
  }
  
  export enum DiscountType {
    LOYALTY = "personal",
    EDU = "edu"
  }

  export enum SamplePackTypes {
    All = "ALL",
    Aif = "AIFF",
    Kemper = "KEMPER",
    SGear = "SGEAR",
    Wave = "WAVE",
    Fractal = "FRACTAL"
  }
  